import React, { useState, useEffect } from 'react';
import ExperienceCard from 'components/Cards/ExperienceCard';
import ToggleDetail from 'components/ToggleDetail';
import ExperienceFormWrapper from 'components/Forms/ExperienceFormWrapper';
import { get } from 'services';
import { connect } from 'react-redux';
import { SetLoading } from "redux/actions/loadingActions";
import WarningNotiifcation from 'components/WarningNotification';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Alerts from 'utils/alerts' 
import Spinner from 'react-bootstrap/Spinner'
import Navigation from "components/Navigation";
import ValidateToken from "components/ValidToken";

const ExperienceModule = ({user}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [showDetail, setShowDetail] = useState(true);
  const [data, setData] = useState([]);
  const [meses, setMeses] = useState([]);


  useEffect(() => {
    (async function mounted() {
      try {
        setIsLoading(true);
        if (!user.persona.personaExperiencias || (user.persona.personaExperiencias && user.persona.personaExperiencias.length === 0)) {
          const response = await get(`PersonaExperiencia/GetByPersonaId/${user.persona.id}`);
          user.persona.personaExperiencias = response.data;
        } 

        if (user.persona.personaExperiencias && user.persona.personaExperiencias.length > 0 && user.persona.personaExperiencias.filter(x => x.estado != 0).length > 0) {
          setShowDetail(true);
        } else {
          setShowDetail(false);
        }

        const mesResponse = await get(`Mes`);
        setMeses(mesResponse.data)
        const data = user.persona.personaExperiencias && user.persona.personaExperiencias.length > 0 ? user.persona.personaExperiencias.filter(x => x && x.estado === 1) : [];
        setData(data);
      } catch (error) {
        Alerts.operationFail()
      } finally {
        setIsLoading(false)
      }
    })();
  }, []);


  return (
    <>
      <ValidateToken/>
      <div className={''}>
        {
          isLoading &&
          <div className={'display-flex flex-direction-row flex-center'}>
              <Spinner 
                animation="grow" 
                variant="primary" 
                className={'is-absolute center-spinner-vertically'} 
                size="lg" />
          </div>
        }
        <ToggleDetail initState={showDetail}  onToggleDetail={setShowDetail} label="Experiencias"/>
        { 
          showDetail ? 
          <div> 
            { 
              (data && data.length > 0) ? <ExperienceCard meses={meses} data={data}/>
              : <Form.Group as={Col} md="12">
              <WarningNotiifcation message='No ha agregado ' enphasis='experiencias'/>
            </Form.Group>
            }
            <br/>
            <Navigation beforeUrl="/knowledgeAndSkillsModule" continueUrl="/reference" />
          </div>
          : 
          <div> 
            <ExperienceFormWrapper data={data}/>
          </div>
        }
      </div>
    </>
  )
}
const mapStateToProps = (state) => {
  return {
      user: state.user
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    SetLoading: (value) => dispatch(SetLoading(value))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ExperienceModule);
